import { sectionTitleSlideV2 } from '../shared/section-title-slide-v2';

export const appendixTitleSlideV2 = () => sectionTitleSlideV2('Appendix');
